<template>
	<div>
		<sBox title="Grade de colaboradores">
			<div slot="tools">
				<aBtn
					action="private-save-collaborators"
					@click="$refs.modal.open()"
					text="Colaboradores"
					icon="plus"
					size="sm"
					type="success"
				/>
			</div>
			<div slot="body">
				<br />
				<sBox title="Filtrar Colaboradores">
					<div class="row" slot="body">
						<div class="col-sm-3">
							<span>Nome</span>
							<input
								v-model="filter.nome"
								@input="fxFilter('nome', $event.target.value)"
								type="text"
								class="form-control"
								placeholder="NOME"
							/>
						</div>
						<div class="col-md-3">
							<span>CPF</span>
							<input
								v-model="filter.CPF"
								type="text"
								class="form-control"
								v-mask="'###.###.###-##'"
								@input="fxFilter('CPF', $event.target.value)"
								ref="cpf"
								id="cpf"
								placeholder="999.999.999-99"
							/>
						</div>
						<div class="col-sm-2">
							<span>RG</span>
							<input
								v-model="filter.RG"
								v-mask="'##.###.###-#'"
								placeholder="99.999.999-9"
								@input="fxFilter('RG', $event.target.value)"
								type="text"
								class="form-control"
							/>
						</div>
						<div class="col-sm-2">
							<span>Email</span>
							<input
								v-model="filter.email"
								@input="fxFilter('email', $event.target.value)"
								type="email"
								class="form-control"
								placeholder="EMAIL"
							/>
						</div>
						<div class="col-sm-2">
							<span>Setor</span>
							<input
								v-model="filter.setor"
								@input="fxFilter('setor', $event.target.value)"
								type="text"
								class="form-control"
								placeholder="SETOR"
							/>
						</div>
					</div>
				</sBox>
				<br />
				<sTable
					ref="tab"
					actionRead="private-read-pessoas"
					actionDelete="private-delete-pessoas"
					:labels="labels"
					:actions="['delete', 'edit']"
					:functions="functions"
					@edit="(data) => $refs.modal.open(data)"
				/>
			</div>
		</sBox>
		<modal ref="modal" @update="$refs.tab.updateTable()" />
	</div>
</template>
<script>
	// import WBS from 'js/http'
	import sTable from 'table';
	import sBox from 'box';
	import aBtn from 'btn';
	import modal from './modal.vue';
	import pad from 'js/pad';
	import { mapState } from 'vuex';

	export default {
		name: 'AppCadastroCol',
		components: { sTable, sBox, modal, aBtn },
		data() {
			return {
				filter: {
					nome: '',
					CPF: '',
					RG: '',
					email: '',
					setor: '',
				},

				labels: [
					{ data: 'CPF', label: 'CPF' },
					{ data: 'nome', label: 'Nome' },
					{ data: 'setor', label: 'Setor' },
					{ data: 'funcao', label: 'Função' },
					{ data: 'CBO', label: 'CBO' },
					{ data: 'RG', label: 'RG' },
					{ data: 'dataNasc', label: 'Data nascimento' },
					{ data: 'sexo', label: 'Sexo' },
					{ data: 'dataAdm', label: 'Data de Admissão' },
					{ data: 'eSocial', label: 'E-Social' },
					{ data: 'cel', label: 'Celular' },
					{ data: 'email', label: 'Email' },
					{ data: 'biometria', label: 'Biometria' },
				],
				functions: [
					{
						cod: 'CPF',
						fx: (val) => {
							return val
								.toString()
								.replace(
									/(\d{3})(\d{3})(\d{3})(\d{2})/g,
									'\$1.\$2.\$3\-\$4'
								);
						},
					},
					{
						cod: 'RG',
						fx: (val) => {
							return val
								.toString()
								.replace(
									/(\d{2})(\d{3})(\d{3})(\d{1})/g,
									'\$1.\$2.\$3\-\$4'
								);
						},
					},
				],
			};
		},
		computed: {
			...mapState(['user_data']),
		},
		methods: {
			fxFilter(col, val) {
				let f = [];
				if (this.filter.nome != '')
					f.push(`nome like '%${this.filter.nome}%'`);
				if (this.filter.CPF != '')
					f.push(
						`CPF like '%${this.filter.CPF.replace(
							/[^\w\s]/gi,
							''
						)}%'`
					);
				if (this.filter.RG != '')
					f.push(
						`RG like '%${this.filter.RG.replace(/[^\w\s]/gi, '')}%'`
					);
				if (this.filter.email != '')
					f.push(`email like '%${this.filter.email}%'`);
				if (this.filter.setor != '')
					f.push(`setor like '%${this.filter.setor}%'`);
				f = f.join(' and ');
				if (f != '') this.$refs.tab.setFilter(f);
				else this.$refs.tab.setFilter('');
				this.$refs.tab.updateTable();
			},
		},
		mounted() {
			this.$emit('setHeader', ['Gerenciamento de Colaboradores', '']);
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/cadastros/colaboradores/index.vue